/* eslint-disable @typescript-eslint/no-explicit-any */

// React import not needed for JSX in React 17+
import { useSelector } from "react-redux";
import { SntDataCard } from "./SntDataCard/SntDataCard";
import { SntDataTable } from "./SntDataTable/SntDataTable";

import { RootState } from "@/types/RootState";

interface SntTableViewCardProps {
  isDynamicDashBoard?: boolean;
  dataFilter?: any;
  data?: any;
  [key: string]: unknown;
}

export const SntTableViewCard = (props: SntTableViewCardProps) => {
  const { isMobile } = useSelector((state: RootState) => state.all);

  return isMobile && !props.isDynamicDashBoard ? (
    <SntDataCard {...(props as any)} />
  ) : (
    <SntDataTable {...(props as any)} />
  );
};
